import { styled } from "@mui/material";

export const StyledRangePickersDayWrapper = styled("div", {
  shouldForwardProp: (prop: string) =>
    ![
      "isInSelectedRange",
      "isSelectedRangeStart",
      "isSelectedRangeEnd",
      "isInHoveredRange",
      "isHoveredRangeStart",
      "isHoveredRangeEnd",
      "isStartOfWeek",
      "isEndOfWeek",
      "isStartOfMonth",
      "isEndOfMonth",
    ].includes(prop),
})<{
  isInSelectedRange?: boolean;
  isSelectedRangeStart?: boolean;
  isSelectedRangeEnd?: boolean;
  isInHoveredRange?: boolean;
  isHoveredRangeStart?: boolean;
  isHoveredRangeEnd?: boolean;
  isStartOfWeek?: boolean;
  isEndOfWeek?: boolean;
  isStartOfMonth?: boolean;
  isEndOfMonth?: boolean;
}>`
  border: 1px solid transparent;

  .MuiPickersDay-root {
    margin: 0;
  }

  &:has(:not(.MuiPickersDay-hiddenDaySpacingFiller)) {
    ${(props) =>
      props.isInSelectedRange &&
      `
		 		background-color: ${props.theme.wsc.palette.primary[700]};
		`}

    ${(props) =>
      (props.isStartOfWeek ||
        (props.isInSelectedRange &&
          (props.isSelectedRangeStart || props.isStartOfMonth)) ||
        (props.isInHoveredRange &&
          (props.isHoveredRangeStart || props.isStartOfMonth))) &&
      `
				border-top-left-radius: ${props.theme.wsc.radius.half};
				border-bottom-left-radius: ${props.theme.wsc.radius.half};
		`}

		${(props) =>
      (props.isEndOfWeek ||
        (props.isInSelectedRange &&
          (props.isSelectedRangeEnd || props.isEndOfMonth)) ||
        (props.isInHoveredRange &&
          (props.isHoveredRangeEnd || props.isEndOfMonth))) &&
      `
				border-top-right-radius: ${props.theme.wsc.radius.half};
				border-bottom-right-radius: ${props.theme.wsc.radius.half};
		`}

		${(props) =>
      props.isInHoveredRange &&
      `
				border-top: 1px dashed ${props.theme.wsc.palette.primary[100]};
				border-bottom: 1px dashed ${props.theme.wsc.palette.primary[100]};
		`}

		${(props) =>
      props.isInHoveredRange &&
      (props.isHoveredRangeStart ||
        props.isStartOfWeek ||
        props.isStartOfMonth) &&
      `
				border-left: 1px dashed ${props.theme.wsc.palette.primary[100]};
		`}

		${(props) =>
      props.isInHoveredRange &&
      (props.isHoveredRangeEnd || props.isEndOfWeek || props.isEndOfMonth) &&
      `
				border-right: 1px dashed ${props.theme.wsc.palette.primary[100]};
		`}
  }
`;
